import moment from "moment/moment";
export class SessionTimeUtils {
    static calculateMinutesPassedFromSessionEndTime(session) {
        const sessionEnd = moment(session.sessionStartTime).add(session.duration, 'minutes');
        const now = moment();
        const minutesPassed = now.diff(sessionEnd, 'minutes');
        return minutesPassed;
    }
}
